module.exports = __webpack_public_path__ + "static/4pilares-1140-4cbabc99dd80ad12d6c8a2d9a1b783f6.jpg";